module.exports = __webpack_public_path__ + "static/img/cd_yy.3ef25b45.png";